import { SelectItem, Select as UiSelect, SelectProps as UiSelectProps } from "@heroui/react";
import { Controller, FieldPath, FieldValues, useFormContext } from "react-hook-form";

export interface SelectProps<T extends FieldValues> extends Omit<UiSelectProps, "children"> {
	name: FieldPath<T>;
	options: Array<{ label: string; value: string }>;
}

export function Select<T extends FieldValues>(props: SelectProps<T>) {
	const form = useFormContext();

	const { name, options, ...rest } = props;

	const fieldState = form.getFieldState(name, form.formState);
	console.log("fieldState", fieldState.error, name);

	return (
		<Controller
			name={name}
			control={form.control}
			render={({ field }) => (
				<UiSelect
					{...rest}
					selectedKeys={field.value ? [field.value] : []}
					onChange={(e) => field.onChange(e.target.value)}
					isInvalid={!!fieldState.error}
					errorMessage={fieldState.error?.message}
				>
					{options.map((option) => {
						return <SelectItem key={option.value}>{option.label}</SelectItem>;
					})}
				</UiSelect>
			)}
		/>
	);
}
